export default __webpack_public_path__ + "images/symbols.svg?6bd5879cb9a032639fb375ff6f1dcd26";